<div class="page-detail">
    <div class="page-detail-content">
        <cp-page-view [title]="pageTitle" [details]="details"></cp-page-view>
    </div>
</div>
